import { setDisableScrolling } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import { showLoginPopup } from '@/common/utils/player'

/**
 * 상세 페이지 (vod, movie, live등)에서 공통사용되는 mixin
 * delegate를 통한 플레이어와의 통신 후처리
 * 그외 공통 기능
 * WARNING :: 플레이어 전용 페이지 stream
 * TODO :: 비사용로직 정리 필요
 */
export default {
  data () {
    return {
      shareLayout: false,
      downloadLayout: false,
      downloadContentId: '',
      downloadContentType: '',
    }
  },
  methods: {
    replaceState (url) {
      this.$router.replace(url)
    },
    openDownloadPopup () {
      if (cookie.getCredential() === 'none') {
        showLoginPopup()
      } else {
        this.downloadLayout = true
        setDisableScrolling(true)
      }
    },
    closeDownloadLayout () {
      this.downloadLayout = false
      setDisableScrolling(false) // 윈도우 스크롤 사용
    },
    // 공유 레이어 팝업 닫기
    openShareLayout () {
      this.shareLayout = true
    },
    closeShareLayout () {
      this.shareLayout = false
    }
  }
}
